import { Icon } from "@newsela/angelou";

import RawFormativeLogoIcon from "./RawFormativeLogoIcon.svg.jsx";

const FormativeLogoIcon = (props) => {
  return <Icon SvgComponent={RawFormativeLogoIcon} {...props} />;
};

export default FormativeLogoIcon;
